// import React, { useEffect } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import LiveCoordination from '../../../Assets/UserSide/LivewithCoordinationimgs.png';
// import img1 from '../../../Assets/UserSide/wife.svg';
// import img2 from '../../../Assets/UserSide/pracking.svg';
// import img3 from '../../../Assets/UserSide/jym.svg';
// import img4 from '../../../Assets/UserSide/free.svg';
// import img5 from '../../../Assets/UserSide/support.svg';
// import img6 from '../../../Assets/UserSide/locker.svg';

// const DescriptionAmenities = () => {
//     useEffect(() => {
//         AOS.init({
//             duration: 1000, // Animation duration
//             easing: 'ease-in-out', // Animation easing
//             once: true, // Animation happens only once when scrolled into view
//         });
//     }, []);

//     return (
//         <div className="mt-10 tracking-wide">
//             <h1
//                 className="lg:text-5xl md:text-4xl text-2xl font-bold text-center text-blue-900 mb-6"
//                 data-aos="fade-up"
//             >
//                 Description of PG and Amenities
//             </h1>
//             <p
//                 className="text-center text-gray-600 md:max-w-[70%] md:mx-auto mb-10 mx-6"
//                 data-aos="fade-up"
//             >
//                 In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.
//             </p>

//             {/* Section 1 */}
//             <div className="grid grid-cols-1 lg:grid-cols-5 items-center gap-4">
//                 <img
//                     alt="Live"
//                     src={LiveCoordination}
//                     className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
//                     data-aos="fade-right"
//                 />
//                 <div
//                     className="col-span-3 bg-[#E9EDF4] p-6 lg:rounded-l-[5rem] flex flex-col justify-center h-full"
//                     data-aos="fade-left"
//                 >
//                     <h2 className="text-3xl font-bold text-gray-900 mb-4">
//                         Live with Coordination
//                     </h2>
//                     <p className="text-gray-600 lg:text-[1.1rem] md:max-w-[95%]">
//                         Live with Coordination emphasizes the importance of harmonizing various aspects of life to achieve balance and efficiency. It involves synchronizing your actions, goals, and relationships to work smoothly together, much like different parts of a well-orchestrated team. Living with coordination requires thoughtful planning, clear communication, and adaptability to handle different situations seamlessly.
//                     </p>
//                 </div>
//             </div>

//             {/* Section 2 */}
//             <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center mt-10">
//                 <div
//                     className="col-span-3 bg-[#E9F4E9] p-6 lg:rounded-r-[5rem] flex flex-col justify-center h-full md:pl-16"
//                     data-aos="fade-right"
//                 >
//                     <h2 className="text-3xl font-bold text-gray-900 mb-4">
//                         Flexibility of Choosing Food
//                     </h2>
//                     <p className="text-gray-600 lg:text-[1.1rem] md:max-w-[95%]">
//                         Having the flexibility to choose your food allows individuals to make dietary choices that align with their health needs, preferences, and lifestyle. It empowers people to select from a variety of options, catering to personal tastes, dietary restrictions, and nutritional goals. This freedom enhances satisfaction and enjoyment of meals, promotes better adherence to dietary plans, and supports diverse cultural and ethical food choices.
//                     </p>
//                 </div>
//                 <img
//                     alt="Live"
//                     src={LiveCoordination}
//                     className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
//                     data-aos="fade-left"
//                 />
//             </div>

//             {/* Section 3 */}
//             <div className="grid grid-cols-1 lg:grid-cols-5 items-center mt-10 gap-4">
//                 <img
//                     alt="Live"
//                     src={LiveCoordination}
//                     className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
//                     data-aos="fade-right"
//                 />
//                 <div
//                     className="col-span-3 bg-[#E9EDF4] p-6 lg:rounded-l-[5rem] flex flex-col justify-center h-full"
//                     data-aos="fade-left"
//                 >
//                     <h2 className="text-3xl font-bold text-gray-900 mb-4">
//                         Chores Taken Care of
//                     </h2>
//                     <p className="text-gray-600 lg:text-[1.1rem] md:max-w-[95%]">
//                         Imagine coming home to a clean, organized space without lifting a finger. With “Chores Taken Care of,” daily tasks like cleaning, laundry, and tidying up are managed for you, giving you back time to focus on what matters most.
//                     </p>
//                 </div>
//             </div>

//             {/* Section 4 */}
//             <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center mt-10">
//                 <div
//                     className="col-span-3 bg-[#E9F4E9] p-6 lg:rounded-r-[5rem] flex flex-col justify-center h-full md:pl-16"
//                     data-aos="fade-right"
//                 >
//                     <h2 className="text-3xl font-bold text-gray-900 mb-4">
//                         Step into a Room that has Everything
//                     </h2>
//                     <div
//                         className="grid grid-cols-2 mt-10 sm:grid-cols-3 lg:grid-cols-3 grid-rows-3 md:gap-8"
//                         data-aos="fade-up"
//                     >
//                         {[img1, img2, img3, img4, img5, img6].map((img, index) => (
//                             <div
//                                 key={index}
//                                 className="flex items-center space-x-4 hover:translate-y-[-5px] transform transition-transform duration-300"
//                             >
//                                 <img src={img} alt={`img${index}`} className="w-8 h-8" />
//                                 <p className='lg:text-xl md:text-md text-sm'>
//                                     {[
//                                         'Free High Speed WiFI',
//                                         'Parking Place',
//                                         'Jym',
//                                         'Free Luggage Storage',
//                                         '24*7 Support',
//                                         'Lockers',
//                                     ][index]}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <img
//                     alt="Live"
//                     src={LiveCoordination}
//                     className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
//                     data-aos="fade-left"
//                 />
//             </div>
//         </div>
//     );
// };

// export default DescriptionAmenities;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import LiveCoordination from "../../../Assets/UserSide/LivewithCoordinationimgs.png";
import Image2 from "../../../Assets/UserSide/Image 2.png";
import Image3 from "../../../Assets/UserSide/Image 3.png";
import img1 from "../../../Assets/UserSide/wifi.svg";
import img2 from "../../../Assets/UserSide/furnished.svg";
import img3 from "../../../Assets/UserSide/cleaning.svg";
import img4 from "../../../Assets/UserSide/ac.svg";
import img5 from "../../../Assets/UserSide/pStorage.svg";
import img6 from "../../../Assets/UserSide/cctv.svg";
import img7 from "../../../Assets/UserSide/refrigerator.svg";
import img8 from "../../../Assets/UserSide/laundry.svg";
import AlwaysHaveUs from "../../../Assets/UserSide/AlwaysHaveUs.png";
const DescriptionAmenities = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
  }, []);

  return (
    <div className="mt-10 tracking-wide">
      <h1
        className="lg:text-lg md:text-sm text-xs font-semibold text-center text-[#E14118] mb-6 italic"
        data-aos="fade-up"
        style={{ fontFamily: '"Montserrat", sans-serif' }}
      >
        Discover How Our Accommodations Redefine Comfortable Living
      </h1>
      <p
        className=" tracking-wide sm:pb-20 pb-10 flex flex-col gap-3"
        data-aos="fade-right"
        style={{ fontFamily: '"Reem Kufi", sans-serif' }}
      >
        <span className="text-center sm:text-4xl text-3xl font-bold ">
          Beyond Four Walls:
        </span>
        <span className="sm:text-4xl text-3xl font-bold text-center ">
          {" "}
          Experience Exceptional Hostels and PGs in Bhubaneswar
        </span>
      </p>

      {/* Section 1 */}
      <div className="grid grid-cols-1 lg:grid-cols-5 items-center gap-4">
        <img
          alt="Live"
          src={LiveCoordination}
          className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
          data-aos="fade-right"
        />
        <div
          className="col-span-3 bg-[#E8F4FF] p-6 lg:rounded-l-[5rem] flex flex-col justify-center h-full"
          data-aos="fade-left"
        >
          <h2
            className="text-3xl font-bold text-[#081021] mb-4 sm:text-center text-start xl:px-24 sm:px-10 px-0 tracking-wide leading-10"
            style={{ fontFamily: '"Roboto", sans-serif' }}
          >
            Fully Furnished Hostels and PGs in Bhubaneswar—Move In and Start
            Living
          </h2>
          <p className="text-[1.2rem] sm:text-center text-start xl:px-24 sm:px-10 px-0 tracking-wide sm:w-[74%] w-full sm:mx-auto mx-0 leading-7 text-gray-600 mb-6">
            Arrive with Your Aspirations; We've Taken Care of Furniture,
            Appliances, and Meals
          </p>
          <div className="grid xl:grid-cols-4 gap-2 sm:grid-cols-3 grid-cols-2 text-gray-700 xl:px-5 px-2">
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img1} alt="Wifi" />
              </span>{" "}
              Wifi
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img2} alt="Furnished Room" />
              </span>{" "}
              Furnished Room
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img3} alt="Daily Cleaning" />
              </span>{" "}
              Daily Cleaning
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img4} alt="Air Conditioner" />
              </span>{" "}
              Air Conditioner
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img5} alt="Private Storage Facility" />
              </span>{" "}
              Private Storage Facility
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img6} alt=" CCTV" />
              </span>{" "}
              CCTV
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img7} alt=" Refrigerator" />
              </span>{" "}
              Refrigerator
            </div>
            <div className="flex items-center gap-2">
              <span className="">
                <img src={img8} alt=" Laundry" />
              </span>{" "}
              Laundry
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center mt-10">
        <div
          className="col-span-3 bg-[#E8F4FF] p-6 lg:rounded-r-[5rem] flex flex-col justify-center h-full md:pl-16 lg:order-1 order-2"
          data-aos="fade-right"
        >
          <h2 className="text-3xl font-bold text-[#081021] mb-4 sm:text-center text-start xl:px-24 xl:w-[85%] w-full lg:mx-auto mx-0 px-0  tracking-wide leading-10">
            Experience Hassle-Free Living in Bhubaneswar's Premier Hostels and
            PGs
          </h2>
          <p className="text-[1.2rem] sm:text-center text-start xl:px-24 sm:px-10 px-0 tracking-wide xl:w-[85%] w-full sm:mx-auto mx-0 leading-7 text-gray-600 mb-6">
            Focus on Your Goals—Our Professional Team Handles Cleaning, Laundry,
            and Meals
          </p>
        </div>
        <img
          alt="Live"
          src={Image2}
          className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300 lg:order-2 order-1"
          data-aos="fade-left"
        />
      </div> */}

      {/* Section 3 */}
      <div className="grid grid-cols-1 lg:grid-cols-5 items-center mt-10 gap-4">
        <div
          className="col-span-3 bg-[#E8F4FF] p-6 lg:rounded-l-[5rem] flex flex-col justify-center h-full"
          data-aos="fade-left"
        >
          <h2
            className="text-3xl font-bold text-[#081021] mb-4 sm:text-center text-start xl:px-24 xl:w-[74%] w-full lg:mx-auto mx-0 px-0  tracking-wide leading-10 lg:flex block flex-col"
            style={{ fontFamily: '"Roboto", sans-serif' }}
          >
            Savor Homestyle Meals at Our Bhubaneswar Hostels and PGs
          </h2>
          <p className="text-[1.2rem] sm:text-center text-start xl:px-24 sm:px-10 px-0 tracking-wide xl:w-[74%] w-full sm:mx-auto mx-0 leading-7 text-gray-600 mb-6">
            Enjoy Nutritious, Delicious Dishes with Local Flavors That Remind
            You of Home
          </p>
        </div>
        <img
          alt="Live"
          src={Image3}
          className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
          data-aos="fade-right"
        />
      </div>

      {/* Section 4 */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center mt-10">
        <img
          alt="Live"
          src={AlwaysHaveUs}
          className="col-span-2 mx-auto w-[85%] hover:scale-105 transform transition-transform duration-300"
          data-aos="fade-right"
        />
        <div
          className="col-span-3 bg-[#E8F4FF] p-6 lg:rounded-r-[5rem] flex flex-col justify-center h-full md:pl-16 lg:order-1 order-2"
          data-aos="fade-right"
        >
          <h2
            className="text-3xl font-bold text-[#081021] mb-4 sm:text-center text-start xl:px-24 xl:w-[90%] w-full lg:mx-auto mx-0 px-0  tracking-wide leading-10"
            style={{ fontFamily: '"Roboto", sans-serif' }}
          >
            Always Have Us At Your Fingertips
          </h2>
          <p className="text-[1.2rem] sm:text-center text-start xl:px-24 sm:px-10 px-0 tracking-wide xl:w-[90%] w-full sm:mx-auto mx-0 leading-7 text-gray-600 mb-6">
            Our easy-to-use app simplifies dues, complaints, check-ins,
            check-outs, and payments — making your Yostel experience smooth and
            transparent."
          </p>
        </div>
      </div>
    </div>
  );
};

export default DescriptionAmenities;
